import { Navigate, useLocation } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { AuthContext } from 'src/context/AuthContext';
import { StageConnecting, StageNoAccess } from 'src/stage/StageStatus';

function AdminRoute({ element, permission }) {
  const { auth, isAdmin, permissions, loading, beginLogin, authError } = useContext(AuthContext);
  const location = useLocation();

  useEffect(() => {
    if (!loading && !auth && !authError) beginLogin(`${location.pathname}${location.search}`);
  }, [auth, authError, beginLogin, loading, location.pathname, location.search]);

  if (authError === 'access_denied') {
    return <StageNoAccess />;
  }

  if (loading || !auth) return <StageConnecting />;

  const allowed = isAdmin || (permission && (permissions || []).includes(permission));

  if (!allowed) {
    return <Navigate to="/workspace" replace />;
  }

  return element;
}

export default AdminRoute;
